import {
  faChartLine,
  faClipboardList,
  faHandsHelping,
  faLightbulb,
  faMagnifyingGlass,
  faPeopleArrows,
} from "@fortawesome/free-solid-svg-icons";
import Footer from "../../../components/footer/Footer";
import Imagewheel from "../../../components/imagewheel/Imagewheel";
import Newsletter from "../../../components/newsletter/Newsletter";
import {
  CrisisFirstBottomText,
  CrisisFirstButton,
  CrisisFirstContainer,
  CrisisFirstImage,
  CrisisFirstIntroTitle,
  CrisisFirstLine,
  CrisisFirstText,
  CrisisFirstTextContainer,
  CrisisFirstTitle,
  CrisisPageContainer,
  CrisisSecondCard,
  CrisisSecondCardIcon,
  CrisisSecondCardsContainer,
  CrisisSecondCardText,
  CrisisSecondCardTitle,
  CrisisSecondContainer,
  CrisisSecondIntroTitle,
  CrisisSecondTextContainer,
  CrisisSecondTitle,
  CrisisThirdWalkthrough,
} from "./CrisisStyles";
import Walkthrough from "../../../components/walkthrough/Walkthrough";
import { Link } from "react-router-dom";

function Crisis() {
  const images = ["/assets/4.jpg", "/assets/5.jpg", "/assets/8.jpg"];

  return (
    <CrisisPageContainer>
      {/* Commissioners - Crisis: Imagewheel */}
      <Imagewheel images={images} isCrisis={true} />

      {/* Commissioners - Crisis: First Section */}
      <CrisisFirstContainer>
        <CrisisFirstImage src="/assets/22.jpg" alt="Smart Personeel" />
        <CrisisFirstTextContainer>
          <CrisisFirstIntroTitle>Smart Crisis Team</CrisisFirstIntroTitle>
          <CrisisFirstTitle>Plan van aanpak</CrisisFirstTitle>
          <CrisisFirstText>
            Wanneer een zorglocatie onder druk staat door personeelstekorten,
            hoge werkdruk of een crisissituatie, biedt Smart-Personeel dé
            oplossing. Onze Smart Crisis Teams nemen de volledige zorglocatie
            tijdelijk over en brengen direct structuur en stabiliteit.
          </CrisisFirstText>
          <CrisisFirstText>
            Elk team wordt samengesteld op basis van de specifieke behoeften van
            de locatie. Van ervaren begeleiders en verzorgenden tot planners en
            teamleiders – wij zorgen voor een compleet en goed op elkaar
            ingespeeld team. We herstructureren de zorg, stellen duidelijke
            zorgplannen op en nemen de volledige planning over. Ook
            contractzaken en facturatie kunnen wij volledig uit handen nemen,
            zodat de focus weer op de zorg ligt.
          </CrisisFirstText>
          <CrisisFirstText>
            Zodra je ons inschakelt, wordt er direct een vast contactpersoon
            aangewezen die alles in gang zet en nauw met je samenwerkt. Door
            onze ervaring in verschillende zorgsectoren weten we precies wat
            nodig is om rust en continuïteit terug te brengen.
          </CrisisFirstText>
          <CrisisFirstBottomText>
            Benieuwd naar deze oplossing?
          </CrisisFirstBottomText>
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <CrisisFirstButton>Neem contact op</CrisisFirstButton>
          </Link>
          <CrisisFirstLine />
        </CrisisFirstTextContainer>
      </CrisisFirstContainer>

      {/* Commissioners - Crisis: Second Section */}
      <CrisisSecondContainer>
        <CrisisSecondTextContainer>
          <CrisisSecondIntroTitle>
            Flexibel met behoud van kwaliteit
          </CrisisSecondIntroTitle>
          <CrisisSecondTitle>Hoe pakken we het aan?</CrisisSecondTitle>
        </CrisisSecondTextContainer>
        <CrisisSecondCardsContainer>
          <CrisisSecondCard>
            <CrisisSecondCardIcon icon={faMagnifyingGlass} />
            <CrisisSecondCardTitle>
              Inventariseren zorgvraag
            </CrisisSecondCardTitle>
            <CrisisSecondCardText>
              Aan de hand van observaties en interviews brengen we samen met jou
              de exacte (inhoudelijke) support vraag in de kaart en komen we tot
              een nieuwe nauwkeurige probleemanalyse.
            </CrisisSecondCardText>
          </CrisisSecondCard>

          <CrisisSecondCard>
            <CrisisSecondCardIcon icon={faClipboardList} />
            <CrisisSecondCardTitle>
              Opstellen plan van aanpak
            </CrisisSecondCardTitle>
            <CrisisSecondCardText>
              Op basis van de probleemanalyse maken we een passend plan van
              aanpak inclusief alle benodigde expertise voor de specifieke
              supportvaag en strakke planning.
            </CrisisSecondCardText>
          </CrisisSecondCard>

          <CrisisSecondCard>
            <CrisisSecondCardIcon icon={faHandsHelping} />
            <CrisisSecondCardTitle>
              Daadwerkelijke ondersteuning
            </CrisisSecondCardTitle>
            <CrisisSecondCardText>
              We gaan aan de slag op de afgesproken manier en volgens de
              overeengekomen planning. Verlenging kan altijd. eerder overdragen?
              Ook geen probleem!
            </CrisisSecondCardText>
          </CrisisSecondCard>

          <CrisisSecondCard>
            <CrisisSecondCardIcon icon={faChartLine} />
            <CrisisSecondCardTitle>
              Monitoren van kwaliteit
            </CrisisSecondCardTitle>
            <CrisisSecondCardText>
              Gedurende het hele proces blijven we betrokken bij de uitvoering
              van de zorg. Samen met jou monitoren we continu de geleverde
              kwaliteit.
            </CrisisSecondCardText>
          </CrisisSecondCard>

          <CrisisSecondCard>
            <CrisisSecondCardIcon icon={faPeopleArrows} />
            <CrisisSecondCardTitle>Overdracht & Nazorg</CrisisSecondCardTitle>
            <CrisisSecondCardText>
              We bouwen onze ondersteuning strategisch af en dragen de support
              vraag over aan het bestaande team. Zo blijven kennis en kunde
              binnen jouw organisatie.
            </CrisisSecondCardText>
          </CrisisSecondCard>

          <CrisisSecondCard>
            <CrisisSecondCardIcon icon={faLightbulb} />
            <CrisisSecondCardTitle>Kortom</CrisisSecondCardTitle>
            <CrisisSecondCardText>
              Of er nu 1-op-1 begeleiding nodig is, een volledige borglocatie,
              tijdelijk overgenomen dient te worden met als doel weer autonoom
              te functioneren of is er een tijdelijke coach of interim-manager
              nodig. Smart werkt samen met jou om je zorgvraag te beantwoorden.
            </CrisisSecondCardText>
          </CrisisSecondCard>
        </CrisisSecondCardsContainer>
      </CrisisSecondContainer>

      {/* Commissioners - Crisis: Third Section */}
      <CrisisThirdWalkthrough>
        <Walkthrough page="crisis" />
      </CrisisThirdWalkthrough>

      {/* Commissioners - Crisis: Newsletter */}
      <Newsletter />

      {/* Commissioners - Crisis: Footer */}
      <Footer />
    </CrisisPageContainer>
  );
}

export default Crisis;
